import constants from './constants'
import {
  getRouteInfoApiCall,
  saveTimeSheetApiCall,
  getSavedTimeSheetsApiCall,
  getTimeSheetListingApiCall,
  postJobApiCall,
  deleteTimesheetApiCall,
  getEventsApiCall,
  getTimesheetById
} from '../../service/client'
import { OFFICE_USER } from '../../constants/permissions'
import { logServiceError, parseQuery } from '../../utils'

export const setSelectedTimeSheet = timeSheetId => ({ type: constants.SELECT_TIMESHEET, timeSheetId })

export const selectTimeSheet = (timeSheetId) => {
  const query = timeSheetId ? `?id=${timeSheetId}` : ''

  if (parseQuery(History.location.search).id !== (timeSheetId && timeSheetId.toString())) {
    History.push(`/time-sheet${query}`)
  }
  return setSelectedTimeSheet(timeSheetId)
}

const routeInfoFetch = () => ({ type: constants.ROUTE_INFO_FETCH })
const routeInfoSuccess = (routeInfo) => ({ type: constants.ROUTE_INFO_SUCCESS, routeInfo })

export const getRouteInfo = user => dispatch => {
  dispatch(routeInfoFetch())
  return getRouteInfoApiCall(user)
    .then(({ body }) => dispatch(routeInfoSuccess(body)))
}

const timeSheetFetch = () => ({ type: constants.TIMESHEET_FETCH })
const timeSheetSuccess = (timeSheet) => ({ type: constants.TIMESHEET_SUCCESS, timeSheet })

export const saveTimeSheet = (user, timeSheetId, rows, submitted, longNote, shortNote) => dispatch => {
  dispatch(timeSheetFetch())

  return saveTimeSheetApiCall(user, timeSheetId, rows, submitted, longNote, shortNote)
    .then(({ body }) => {
      dispatch(timeSheetSuccess(body))
      dispatch(selectTimeSheet(body.TimeSheetID))
    })
}

const savedTimeSheetSuccess = timeSheets => ({ type: constants.SAVED_TIMESHEET_SUCCESS, timeSheets })

export const getSavedTimeSheets = (user, startDate, endDate, isPrinted, invoiceIsPrinted) => dispatch => {
  dispatch(timeSheetFetch())
  const timeSheetUsername = user.permissions.includes(OFFICE_USER) ? null : user.username
  return getSavedTimeSheetsApiCall(user, timeSheetUsername, startDate, endDate, isPrinted, invoiceIsPrinted)
    .then(({ body }) => dispatch(savedTimeSheetSuccess(body)))
}

export const getTimeSheetListing = (user, startDate, endDate, isPrinted, invoiceIsPrinted) => dispatch => {
  dispatch(timeSheetFetch())
  const timeSheetUsername = user.permissions.includes(OFFICE_USER) ? null : user.username
  return getTimeSheetListingApiCall(user, timeSheetUsername, startDate, endDate, isPrinted, invoiceIsPrinted)
    .then(({ body }) => dispatch(savedTimeSheetSuccess(body)))
}

export const getSavedTimeSheetById = (user, timesheetId) => dispatch => {
  dispatch(timeSheetFetch())
  return getTimesheetById(user, timesheetId)
    .then(({ body }) => dispatch(savedTimeSheetSuccess(body)))
}

export const submitJob = (user, timeSheetId, vendorId, rows, longNote, shortNote) => dispatch => {
  return postJobApiCall(user, timeSheetId, vendorId, rows, longNote, shortNote)
    .then(({ body }) => {
      dispatch(timeSheetSuccess(body))
    })
    .catch(err => {
      logServiceError('submitJob', err)
      return Promise.reject(err)
    })
}

export const deleteTimesheet = (user, timesheetId) => dispatch => {
  return deleteTimesheetApiCall(user, timesheetId)
    .then(() => {
      dispatch({ type: constants.DELETE_TIMESHEET, timesheetId })
    })
}

export const getEvents = (user) => dispatch => {
  return getEventsApiCall(user)
    .then(({ body }) => dispatch({ type: constants.EVENTS_SUCCESS, events: body }))
}

export const setRealTimeFilters = (filters) => dispatch => {
  dispatch({ type: constants.SET_FILTERS, filters })
}